// src/components/Skeletons/JobsCreatedTableSkeletonRow.tsx

import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
`;

const Tr = styled.tr`
  &:nth-of-type(odd) {
    background: #f0f0f0;
  }
`;

const SkeletonTd = styled.td`
  padding: 30px 8px;
  height: 1.5rem;
  background: ${({ theme }) => theme.palette.greyGrey4};
  background-image: linear-gradient(90deg, ${({ theme }) => theme.palette.greyGrey4}, #f0f0f0, ${({ theme }) => theme.palette.greyGrey4});
  background-size: 200px 100%;
  background-repeat: no-repeat;
  animation: ${shimmer} 1.5s infinite;
`;

const JobsCreatedTableSkeletonRow: React.FC = () => (
  <Tr>
    <SkeletonTd colSpan={7} />
  </Tr>
);

export default JobsCreatedTableSkeletonRow;
